import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./experiencesection.css";

const ExperienceSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="experience-section bg-darkblue py-5">
      <div className="container px-0">
        <div className="row g-0 align-items-center">
          {/* Left Image */}
          <div
            className="col-lg-6 text-center bg-darkblue position-relative"
            data-aos="fade-right"
          >
            <div className="worker-image-container">
              <img
                src="/assets/img/housekeeping.png"
                alt="Housekeeping Worker"
                className="img-fluid worker-image"
              />
            </div>
          </div>

          {/* Right Content */}
          <div
            className="col-lg-6 text-white p-5 bg-darkblue"
            data-aos="fade-left"
          >
            <h1 className="fw-bold mb-4" style={{ lineHeight: "1.3" }}>
              We have over <span className="text-danger">10 years</span> of
              experience in Next Level Housekeeping & Facility
              Management
            </h1>

            <div className="row g-4">
              <div className="col-md-6" data-aos="zoom-in" data-aos-delay="200">
                <h6 className="fw-bold text-danger mb-1">→ Client Focused</h6>
                <p className="text-light small mb-0">
                  Services to meet client’s specific needs and aspirations
                  through comprehensive training programs and budget-friendly
                  solutions.
                </p>
              </div>

              <div className="col-md-6" data-aos="zoom-in" data-aos-delay="300">
                <h6 className="fw-bold text-danger mb-1">→ We Build Future</h6>
                <p className="text-light small mb-0">
                  Our specialized team provides services to the best of our
                  abilities and in the highest standards possible.
                </p>
              </div>

              <div className="col-md-6" data-aos="zoom-in" data-aos-delay="400">
                <h6 className="fw-bold text-danger mb-1">
                  → Efficient Building
                </h6>
                <p className="text-light small mb-0">
                  Emphasis on recruitment, selection & training to serve our
                  clients with state-of-the-art services.
                </p>
              </div>

              <div className="col-md-6" data-aos="zoom-in" data-aos-delay="500">
                <h6 className="fw-bold text-danger mb-1">
                  → Skilled and Reliable Staff
                </h6>
                <p className="text-light small mb-0">
                  Scrutinize each aspect while hiring contractors to offer
                  skilled and well-trained staff.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
